import Confirm from './Confirm';

export default function confirm(props = {}) {
  const instance = new Confirm(props);

  return instance.open();
}
